import React, {useEffect, useState} from 'react'
import CoinMarket from './CoinMarket';
import WalletCards from '../Wallet/WalletCards';

import Cards from '../Cards/Cards';
import MobileMenu from './MobileMenu';
import NewCard from '../Cards/NewCard';
import { Divider } from '@mui/material';
import BalanceCard from '../Cards/BalanceCard';

import { Card, CardContent, Typography, Grid, Box, Avatar, LinearProgress, Chip, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import SearchButton from '../Search/SearchButton';
import BlogSlider from '../Blog/BlogSlider';
import MarketTabs from '../Markets/MarketTabs';
import InvestmentSlide from '../BybitTrade/CoinSlide';

import ListStock from '../Stock/ListStock'
import StockSlide from '../Stock/StockSlide';

// Financial Dashboard Icons
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import GroupIcon from '@mui/icons-material/Group';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SavingsIcon from '@mui/icons-material/Savings';
import PaidIcon from '@mui/icons-material/Paid';
import { Link as RouterLink } from 'react-router-dom';

const Index = () => {

  const appMode = useSelector((state) => state.mode.mode);
  const user = useSelector((state) => state.user.user);
  const fundingBal = useSelector((state) => state.wallet.fundingBalance);
  const subBal = useSelector((state) => state.wallet.subscriptionBalance);
  const refBal = useSelector((state) => state.wallet.referralBalance);
  const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
  
  // Get actual data from Redux store
  const plans = useSelector((state) => state.plans.plans);
  const traders = useSelector((state) => state.traders.traders);
  
  const [ip, setIP] = useState("192.168.23.5");
  
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  const getData = async () => {
    fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => setIP(data.ip))
    .catch(error => console.log(error))
  };

  useEffect(() => {
    getData();
  }, []);

  // Transform traders data to investment opportunities format
  const investmentOpportunities = traders.slice(0, 3).map(trader => ({
    id: trader.id,
    title: trader.trader_name,
    description: trader.description || `Professional ${trader.level} trader with proven track record`,
    targetAmount: parseFloat(trader.min_amount) * 10, // Estimate target amount
    raisedAmount: parseFloat(trader.min_amount) * 5, // Estimate raised amount
    expectedReturn: `${trader.gain}%`,
    duration: trader.duration,
    riskLevel: trader.risk_score <= 3 ? 'Low' : trader.risk_score <= 5 ? 'Medium' : 'High',
    category: trader.category || 'Trading',
    trader: trader
  }));

  const getRiskColor = (risk) => {
    switch(risk) {
      case 'Low': return '#4caf50';
      case 'Medium': return '#ff9800';
      case 'High': return '#f44336';
      default: return '#9e9e9e';
    }
  };

  const balanceCardStyles = {
    p: 1.5,
    borderRadius: 2,
    background: appMode === 'dark'
      ? 'linear-gradient(135deg, rgba(31,41,55,0.92), rgba(17,24,39,0.88))'
      : 'linear-gradient(135deg, rgba(229,231,235,0.96), rgba(209,213,219,0.92))',
    border: 'none',
    boxShadow: appMode === 'dark'
      ? '0 8px 20px rgba(0,0,0,0.35)'
      : '0 8px 20px rgba(34,197,94,0.15)',
    textAlign: 'center',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: appMode === 'dark'
        ? '0 12px 28px rgba(0,0,0,0.4)'
        : '0 12px 28px rgba(34,197,94,0.22)'
    }
  };

  const investmentCardStyles = {
    position: 'relative',
    p: 2.5,
    borderRadius: 3,
    height: '100%',
    background: appMode === 'dark'
      ? 'linear-gradient(145deg, rgba(31,41,55,0.92), rgba(17,24,39,0.88))'
      : 'linear-gradient(145deg, rgba(243,244,246,0.98), rgba(229,231,235,0.94))',
    border: appMode === 'dark'
      ? '1px solid rgba(148,163,184,0.15)'
      : '1px solid rgba(148,163,184,0.25)',
    boxShadow: appMode === 'dark'
      ? '0 18px 35px rgba(15,23,42,0.35)'
      : '0 18px 35px rgba(148,163,184,0.25)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(circle at top left, rgba(34,197,94,0.28), transparent 55%)',
      opacity: appMode === 'dark' ? 0.35 : 0.45,
      pointerEvents: 'none'
    },
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: appMode === 'dark'
        ? '0 22px 45px rgba(15,23,42,0.45)'
        : '0 22px 45px rgba(148,163,184,0.35)'
    }
  };

  const crowdFundingCardStyles = {
    position: 'relative',
    p: { xs: 2.5, md: 3 },
    borderRadius: 3,
    background: appMode === 'dark'
      ? 'linear-gradient(150deg, rgba(30,41,59,0.96), rgba(15,23,42,0.88))'
      : 'linear-gradient(150deg, rgba(248,250,252,0.98), rgba(226,232,240,0.94))',
    border: appMode === 'dark'
      ? '1px solid rgba(148,163,184,0.18)'
      : '1px solid rgba(148,163,184,0.25)',
    boxShadow: appMode === 'dark'
      ? '0 22px 45px rgba(15,23,42,0.45)'
      : '0 22px 45px rgba(148,163,184,0.32)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    overflow: 'hidden',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: '-30% 30% 40% -30%',
      background: 'radial-gradient(circle at top, rgba(59,130,246,0.35), transparent 65%)',
      opacity: appMode === 'dark' ? 0.45 : 0.5,
      pointerEvents: 'none'
    },
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: appMode === 'dark'
        ? '0 26px 55px rgba(15,23,42,0.55)'
        : '0 26px 55px rgba(148,163,184,0.38)'
    }
  };

  return (
    <>
    <div style={{height: '65px'}}></div>
    

    {/* Enhanced Balance Card */}
    <BalanceCard/>

    {/* Mobile Menu */}
    <MobileMenu/>

    {/* Account Balances */}
    <Box sx={{ mb: 3, px: { xs: 1, sm: 2 }, width: '100%', mx: 'auto', maxWidth: '1200px' }}>
      <Box sx={{ py: 2, px: { xs: 0, sm: 1 } }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalanceWalletIcon color="primary" />
          Account Balances
        </Typography>
        
        <Grid container spacing={1.5}>
          <Grid item xs={6} sm={3}>
            <Box sx={balanceCardStyles}>
              <AccountBalanceWalletIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(fundingBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Overall Assets
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={balanceCardStyles}>
              <TrendingUpIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(subBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Invested Capital
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={balanceCardStyles}>
              <SavingsIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(mainBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Accumulated Profit
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Box sx={balanceCardStyles}>
              <PaidIcon sx={{ 
                color: appMode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', 
                mb: 0.5,
                fontSize: '1.2rem'
              }} />
              <Typography variant="body2" sx={{ 
                fontWeight: 600, 
                color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                mb: 0.2
              }}>
                {formatPrice(refBal || 0)}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Referral Wallet
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>

    {/* Investment Suite Section */}
    <Box sx={{ mb: 3, px: { xs: 1, sm: 2 }, width: '100%', mx: 'auto', maxWidth: '1200px' }}>
      <Box sx={{ py: 2, px: { xs: 0, sm: 1 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ 
            fontWeight: 'bold', 
            fontSize: { xs: '0.95rem', sm: '1.1rem' },
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <BusinessCenterIcon color="primary" />
            Investment Suite
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {(plans.length > 0 ? plans.slice(0, 6) : [
            { name: 'Starter Plan', min_amount: 100, amount_invested: 999, min_return_percentage: 8, max_return_percentage: 12, investment_duration_range: '1-2 years' },
            { name: 'Premium Plan', min_amount: 1000, amount_invested: 4999, min_return_percentage: 12, max_return_percentage: 18, investment_duration_range: '2-3 years' },
            { name: 'Professional Plan', min_amount: 5000, amount_invested: 19999, min_return_percentage: 18, max_return_percentage: 25, investment_duration_range: '3-5 years' },
            { name: 'Elite Plan', min_amount: 20000, amount_invested: 49999, min_return_percentage: 25, max_return_percentage: 35, investment_duration_range: '5-7 years' },
            { name: 'Ultimate Plan', min_amount: 50000, amount_invested: 1000000, min_return_percentage: 35, max_return_percentage: 50, investment_duration_range: '7-10 years' }
          ]).map((plan, index) => {
            const minReturn = plan.min_return_percentage || parseFloat(plan.total_earning || 8.5).toFixed(2);
            const maxReturn = plan.max_return_percentage || null;
            const duration = plan.investment_duration_range || plan.duration || '30 days';
            const investmentType = plan.investment_type || plan.category || 'Managed Portfolio';

            return (
              <Grid item xs={12} sm={6} md={4} key={plan.id || index}>
                <Box sx={investmentCardStyles}>
                  <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography variant="overline" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.85)' : 'rgba(71,85,105,0.85)' }}>
                      {investmentType}
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: appMode === 'dark' ? '#f8fafc' : '#1f2937', mb: 0.5 }}>
                      {plan.name || `Plan ${index + 1}`}
                    </Typography>
                    <Typography variant="body2" sx={{ color: appMode === 'dark' ? 'rgba(226,232,240,0.75)' : 'rgba(71,85,105,0.85)' }}>
                      {plan.description || 'Diversified growth strategy focusing on high-yield instruments.'}
                    </Typography>
                  </Box>

                  <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                    <Box>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.8)' : 'rgba(100,116,139,0.85)' }}>
                        Min Allocation
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: appMode === 'dark' ? '#f8fafc' : '#1f2937' }}>
                        {formatPrice(plan.min_amount || 100)}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.8)' : 'rgba(100,116,139,0.85)' }}>
                        Target
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: appMode === 'dark' ? '#f8fafc' : '#1f2937' }}>
                        {parseInt(plan.amount_invested) >= 1000000 ? 'Unlimited' : formatPrice(plan.amount_invested || 999)}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.8)' : 'rgba(100,116,139,0.85)' }}>
                        Duration
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: appMode === 'dark' ? '#f8fafc' : '#1f2937' }}>
                        {duration}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.8)' : 'rgba(100,116,139,0.85)' }}>
                      Expected Returns
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: appMode === 'dark' ? '#86efac' : '#16a34a' }}>
                      {maxReturn ? `${minReturn}% - ${maxReturn}%` : `${minReturn}%`}
                    </Typography>
                  </Box>

                  <Button 
                    variant="contained" 
                    sx={{ 
                      alignSelf: 'flex-start',
                      mt: 'auto',
                      textTransform: 'none',
                      borderRadius: 2
                    }}
                    component={RouterLink}
                    to="/package/Investment Suite"
                  >
                    Invest Now
                  </Button>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>

    {/* Investment Opportunities Section */}
    <Box sx={{ mb: 3, px: { xs: 1, sm: 2 }, width: '100%', mx: 'auto', maxWidth: '1200px' }}>
      <Box sx={{ py: 2, px: { xs: 0, sm: 1 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="subtitle1" sx={{ 
            fontWeight: 'bold', 
            fontSize: { xs: '0.95rem', sm: '1.1rem' },
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <GroupIcon color="primary" />
            Crowd Funding
          </Typography>
          <Button 
            size="small" 
            sx={{ textTransform: 'none' }}
            component={RouterLink}
            to="/copy-plans"
          >
            View All
          </Button>
        </Box>
        
        <Grid container spacing={2.5}>
          {(investmentOpportunities.length > 0 ? investmentOpportunities : [
            {
              id: 1,
              title: "Green Energy Infrastructure Fund",
              description: "Invest in renewable energy projects across emerging markets",
              targetAmount: 500000,
              raisedAmount: 325000,
              expectedReturn: "12-15%",
              duration: "24 months",
              riskLevel: "Medium",
              category: "Sustainable Energy"
            },
            {
              id: 2,
              title: "Tech Startup Growth Fund",
              description: "Early-stage technology companies with high growth potential",
              targetAmount: 750000,
              raisedAmount: 445000,
              expectedReturn: "18-25%",
              duration: "36 months",
              riskLevel: "High",
              category: "Technology"
            },
            {
              id: 3,
              title: "Real Estate Development Project",
              description: "Commercial real estate development in prime urban locations",
              targetAmount: 1200000,
              raisedAmount: 890000,
              expectedReturn: "10-12%",
              duration: "18 months",
              riskLevel: "Low",
              category: "Real Estate"
            }
          ]).map((opportunity) => {
            const progressValue = Math.round((opportunity.raisedAmount / opportunity.targetAmount) * 100);

            return (
              <Grid item xs={12} md={4} key={opportunity.id}>
                <Box sx={crowdFundingCardStyles}>
                  <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Chip 
                      label={opportunity.category} 
                      size="small" 
                      sx={{ 
                        mb: 1.5,
                        bgcolor: appMode === 'dark' ? 'rgba(59,130,246,0.2)' : 'rgba(59,130,246,0.12)',
                        color: appMode === 'dark' ? '#93c5fd' : '#1d4ed8',
                        fontWeight: 600,
                        borderRadius: 1.5
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 700, color: appMode === 'dark' ? '#f8fafc' : '#1f2937', mb: 1 }}>
                      {opportunity.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: appMode === 'dark' ? 'rgba(226,232,240,0.78)' : 'rgba(71,85,105,0.88)' }}>
                      {opportunity.description}
                    </Typography>
                  </Box>

                  <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.85)' : 'rgba(100,116,139,0.9)' }}>
                        Progress
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600, color: appMode === 'dark' ? '#f8fafc' : '#1f2937' }}>
                        {progressValue}%
                      </Typography>
                    </Box>
                    <LinearProgress 
                      variant="determinate" 
                      value={progressValue}
                      sx={{ 
                        height: 10, 
                        borderRadius: 999,
                        backgroundColor: appMode === 'dark' ? 'rgba(30,41,59,0.9)' : 'rgba(226,232,240,0.8)',
                        '& .MuiLinearProgress-bar': {
                          borderRadius: 999,
                          background: appMode === 'dark'
                            ? 'linear-gradient(90deg, rgba(59,130,246,0.8), rgba(129,140,248,0.9))'
                            : 'linear-gradient(90deg, rgba(59,130,246,0.75), rgba(129,140,248,0.85))'
                        }
                      }}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.75)' : 'rgba(100,116,139,0.85)' }}>
                        {formatPrice(opportunity.raisedAmount)}
                      </Typography>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.75)' : 'rgba(100,116,139,0.85)' }}>
                        {formatPrice(opportunity.targetAmount)}
                      </Typography>
                    </Box>
                  </Box>

                  <Grid container spacing={1.5} sx={{ position: 'relative', zIndex: 1 }}>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.85)' : 'rgba(100,116,139,0.85)' }}>
                        Expected Return
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: appMode === 'dark' ? '#86efac' : '#16a34a' }}>
                        {opportunity.expectedReturn}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.85)' : 'rgba(100,116,139,0.85)' }}>
                        Duration
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: appMode === 'dark' ? '#f8fafc' : '#1f2937' }}>
                        {opportunity.duration}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: appMode === 'dark' ? 'rgba(148,163,184,0.85)' : 'rgba(100,116,139,0.85)' }}>
                        Risk Level
                      </Typography>
                      <Chip 
                        label={opportunity.riskLevel} 
                        size="small"
                        sx={{ 
                          bgcolor: getRiskColor(opportunity.riskLevel),
                          color: '#fff',
                          fontWeight: 'bold',
                          fontSize: '0.7rem',
                          borderRadius: 1.5,
                          mt: 0.5
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Button 
                    variant="contained" 
                    sx={{ 
                      mt: 'auto', 
                      textTransform: 'none',
                      borderRadius: 2
                    }}
                    component={RouterLink}
                    to={`/view-trades/${opportunity.id}`}
                  >
                    Invest Now
                  </Button>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>

    

    <Divider sx={{ my: 2 }} />
    </>
  )
}

export default Index
